import { Font } from '@react-pdf/renderer';

// ---------------------------------------------------------------------------
// PDF font registration for Urdu support.
//
// @react-pdf/renderer defaults to Helvetica, which has NO Arabic/Urdu glyphs —
// so Urdu text in reports came out blank. Noto Naskh Arabic covers Urdu/Arabic
// AND Latin, so mixed English + Urdu content (names, addresses, remarks) all
// render correctly with a single family. The .ttf files live in
// public/assets/fonts and are loaded at PDF-generation time.
//
// Import this module for its side effect in any report before it renders, then
// set `fontFamily: 'NotoNaskhArabic'` on the report's `page` style (font
// properties cascade to all <Text> inside the page).
// ---------------------------------------------------------------------------
Font.register({
  family: 'NotoNaskhArabic',
  fonts: [
    { src: `${process.env.PUBLIC_URL}/assets/fonts/NotoNaskhArabic-Regular.ttf`, fontWeight: 'normal' },
    { src: `${process.env.PUBLIC_URL}/assets/fonts/NotoNaskhArabic-Bold.ttf`, fontWeight: 'bold' },
  ],
});

// react-pdf hyphenates words by default, which breaks Arabic letter joining.
// Return the word unchanged so Urdu stays connected.
Font.registerHyphenationCallback((word) => [word]);

export const URDU_FONT = 'NotoNaskhArabic';
